import { ReactComponent as Logo } from '../assets/logo.svg';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; 

export default function Navbar() {

  return (
    <nav 
      className="navbar navbar-expand-lg position-fixed w-100 p-0"
      style={{ 
        height: 'auto',
        backdropFilter: 'blur(5px)', 
        zIndex: 1000
      }}
    >
      <div className="container-fluid d-flex flex-row pt-4 py-2">
          {/* Logo Section */}
          <div className='col'>
            <a className="navbar-brand position-fixed" href="#home">
              <Logo className="nav-logo"/>
            </a>
          </div>
          {/* Menu */}
          <div className="col d-flex justify-content-end">
            <button 
              className="navbar-toggler border-0" 
              type="button" 
              data-bs-toggle="collapse" 
              data-bs-target="#navbarNav" 
              aria-controls="navbarNav"
              aria-expanded="false" 
              aria-label="Toggle navigation"
            >
                <i className="bi bi-list"></i>
            </button>            
          </div>
          <div className="collapse navbar-collapse w-100 pt-4 pt-md-0 justify-content-end" id="navbarNav">
            <ul className="navbar-nav flex-row justify-content-center gap-4">
              <a href="#about"><li className="nav-item mx-3">About</li></a>
              <a href="#projects"><li className="nav-item mx-3">Projects</li></a>
              <a href="#contact"><li className="nav-item mx-3">Contact</li></a>
            </ul>
          </div>
        </div>
    </nav>
  );
}